import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from '@material-ui/core/Tooltip';
import tableStyle from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import TableSortLabel from '@material-ui/core/TableSortLabel';
class FilterInput extends React.Component {
  setDefaultStyle(){
    const style = {
      border: 'none',
      borderBottom: '1px solid #d2d2d2',
      width: '100%',
      height: '36px',
      padding: '7px 0',
      fontSize: '14px',
      color: '#555'
    }
    this.setState({style})
  }
  componentWillMount(){
    this.setDefaultStyle()
  }
  change(e){
    this.props.filterChangeAction(e.target.value, this.props.filterKey)
  }
  focus(e){
    const style = {
      border: 'none',
      borderBottom: '1px solid #9c27b0',
      width: '100%',
      height: '36px',
      padding: '7px 0',
      fontSize: '14px',
      color: '#555'
    }
    this.setState({style})
  }
  blur(e){
    this.setDefaultStyle()
  }
  render(){
    
    return(
    <div style={{display: 'block', paddingTop:'10px', position:'relative', bottom: '-8.5px'}}>
      <input
        onFocus={(e) => this.focus(e)}
        onBlur={(e) => this.blur(e)}
        style={this.state.style}
        key={this.props.filterKey}
        value={this.props.value}
        onChange={(e) => this.change(e)} />
    </div>
    )
  }
}
function CustomTable({ ...props }) {
  const {
    classes,
    tableHead,
    tableData,
    tableHeaderColor,
    hover,
    colorsColls,
    coloredColls,
    customCellClasses,
    customClassesForCells,
    striped,
    tableShopping,
    customHeadCellClasses,
    customHeadClassesForCells,
    sort,
    onSort,
    responsiveY,
    filterColumns,
    firstChildFullWidth
  } = props;
  return (
    <div className={classes.tableResponsive + (responsiveY ? ' '+classes.responsiveY : '')}>
      <Table className={classes.table + (firstChildFullWidth? ' '+ classes.tableFirstChild: '')}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor]}>
            <TableRow className={classes.tableRow}>
              {Object.keys(tableHead).map((key) => {
                const prop =tableHead[key]
                const isString = typeof prop === 'string'
                const tableCellClasses =
                  classes.tableHeadCell +
                  " " +
                  filterColumns || filterColumns.length !== 0
                    ? classes.tableHeadCellWithFilters
                    : classes.tableCell +
                  " " +
                  cx({
                    [customHeadCellClasses[
                      customHeadClassesForCells.indexOf(key)
                    ]]:
                      customHeadClassesForCells.indexOf(key) !== -1,
                    [classes.tableShoppingHead]: tableShopping,
                    [classes.tableHeadFontSize]: !tableShopping
                  });
                const filter = filterColumns && filterColumns.find((x) => x.name === key)
                  ? filterColumns.find((x) => x.name === key)
                  : null
                return (
                  <TableCell className={tableCellClasses} key={key}>
                    {sort && typeof sort[key]!=='undefined'
                    ?<Tooltip title="Sort"
                      placement={'bottom-end'}
                      enterDelay={300}
                    >
                      <TableSortLabel active={sort[key]?true:false}
                        direction={sort[key]?sort[key]:'asc'}
                        onClick={()=>onSort(key)}
                        >
                        {isString? prop : <div style={{width: prop.width}}>{prop.name}</div>}
                      </TableSortLabel>
                    </Tooltip>
                    :isString? prop : <div style={{width: prop.width}}>{prop.name}</div>
                    }
                    {filter
                      ? <FilterInput
                          value={filter.value}
                          filterChangeAction={filter.filterChangeAction}
                          filterKey={filter.name}
                        /> : ''}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.map((prop, key) => {
            var rowColor = "";
            var rowColored = false;
            if (prop.color !== undefined) {
              rowColor = prop.color;
              rowColored = true;
              prop = prop.data;
            }
            const tableRowClasses = cx({
              [classes.tableRowHover]: hover,
              [classes[rowColor + "Row"]]: rowColored,
              [classes.tableStripedRow]: striped && key % 2 === 0
            });
            if (prop.total) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={classes.tableCell}
                    colSpan={prop.colspan}
                  />
                  <TableCell
                    className={classes.tableCell + " " + classes.tableCellTotal}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    className={
                      classes.tableCell + " " + classes.tableCellAmount
                    }
                  >
                    {prop.amount}
                  </TableCell>
                  {tableHead.length - (prop.colspan - 0 + 2) > 0 ? (
                    <TableCell
                      className={classes.tableCell}
                      colSpan={tableHead.length - (prop.colspan - 0 + 2)}
                    />
                  ) : null}
                </TableRow>
              );
            }
            if (prop.purchase) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={classes.tableCell}
                    colSpan={prop.colspan}
                  />
                  <TableCell
                    className={classes.tableCell + " " + classes.right}
                    colSpan={prop.col.colspan}
                  >
                    {prop.col.text}
                  </TableCell>
                </TableRow>
              );
            }
            const isFilteringTableFirstRow = 
              filterColumns && key === 0
            return (
              <TableRow
                key={key}
                hover={hover}
                className={classes.tableRow + " " + tableRowClasses}
              >
                {prop.map((prop, key) => {
                  const tableCellClasses =
                  (isFilteringTableFirstRow ? classes.tableCellNoBorderTop : classes.tableCell) +
                    " " +
                    cx({
                      [classes[colorsColls[coloredColls.indexOf(key)]]]:
                        coloredColls.indexOf(key) !== -1,
                      [customCellClasses[customClassesForCells.indexOf(key)]]:
                        customClassesForCells.indexOf(key) !== -1
                    });
                  return (
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [],
  striped: false,
  customCellClasses: [],
  customClassesForCells: [],
  customHeadCellClasses: [],
  customHeadClassesForCells: []
};

CustomTable.propTypes = {
  sort:PropTypes.object,
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  //tableHead: PropTypes.objectOf(PropTypes.node),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  // this will cause some changes in font
  tableShopping: PropTypes.bool
};

export default withStyles(tableStyle)(CustomTable);



// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx